export default __webpack_public_path__ + "static/media/HSTV.67761acb.png";